var exports = {
  "U": "xfd349460--cf8c68--arrow",
};

module.exports = exports;
